import React, { useState } from "react";
import axios from "./../../../../axios";
import { IP } from "./../../../../internalServer";
import { iconData } from "../../../../iconData";
import MideaViewer from "../../../../midea_viewer/MideaViewer";
import { Player } from "video-react";
import ConfirmationPopup from "./ConfirmationPopup";
import { Link } from "react-router-dom";

function AttachmentLM({
  attach,
  fileSize,
  id,
  handleAttach,
  lecture_id,
  scheduled_date,
  dateHelper,
  supplementDataHandle,
  linkValue,
}) {
  const [mideaviewer, setMideaviewer] = useState();
  const [isClicked, setIsClicked] = useState(false);
  const [responseAttach, setResponseAttach] = useState();
  const [isError, setIsError] = useState(false);
  const [isOpenPopup, setIsOpenPopup] = useState(false);

  let attachments = attach;

  const attachformat = (para) => {
    if (para !== undefined) {
      const filePath = para;
      const fileArr = filePath.split("/");
      const fileName = fileArr[fileArr.length - 1];
      const extractedFileName = fileName.split("_")[1];
      return extractedFileName;
    }
  };
  function generateLinkName(attachments) {
    if (!attachments.startsWith("https://")) {
      return "Invalid link";
    }

    // Get today’s date
    const today = new Date();
    const day = String(today.getDate()).padStart(2, "0");
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = today.getFullYear();

    // Format: link_dd-mm-yyyy
    const formattedDate = `${day}-${month}-${year}`;

    return `link_${formattedDate}`;
  }
  // console.log(iconData?.find(
  //   (i) => i.extension === attachments?.split(".").pop()
  // )?.icon);
  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };
  const handleClickforpdf = (attachment) => {
    setResponseAttach(attachment);
    setMideaviewer(true);
  };



  return (
    <div>
      <div
        className=" attachBox m-1 "
        onClick={() => {
          const fileType = attachments.split(".").pop();
          if (
            fileType === "jpg" ||
            fileType === "jpeg" ||
            fileType === "png" ||
            fileType === "mp4" ||
            fileType === "JPG" ||
            fileType === "JPEG" ||
            fileType === "PNG" ||
            fileType === "MP4"
          ) {
            handleClick(attachments);
          } else if (
            fileType === "pdf" ||
            fileType === "PDF" ||
            fileType === "ppt" ||
            fileType === "PPT" ||
            fileType === "PPTX" ||
            fileType === "pptx"
          ) {
            handleClickforpdf(attachments);
          } else if (attachments.startsWith("https://")) {
            window.open(attachments, "_blank", "noopener,noreferrer");
          }
        }}
      >
        <div
          style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}
        >
          {attachments.split(".").pop() === "jpg" ||
            attachments.split(".").pop() === "jpeg" ||
            attachments?.split(".").pop() === "JPEG" ||
            attachments?.split(".").pop() === "JPG" ||
            attachments?.split(".").pop() === "PNG" ||
            attachments.split(".").pop() === "png" ? (
            <div
              className="d-flex align-items-center"
              onClick={() => {
                if (!isError) {
                  handleClick(attachments);
                }
              }}
            >
              <>
                <div
                  // key={index}
                  onClick={() => handleClick(attachments)}
                  className="ContainerUploadedPdf d-flex gap-2 p-1"
                >
                  <div className="d-flex align-items-center pdf_logo">
                    <img
                      src={`${iconData?.find(
                        (i) => i.extension === attachments?.split(".").pop()
                      )?.icon
                        }`}
                      alt=""
                      className="mr-2 hw_defult_attach_type_icon"
                    />
                  </div>
                </div>
              </>
            </div>
          ) : attachments.split(".").pop() === "pdf" ? (
            <div
              className="all_pdf_pre"
              onClick={() => handleClickforpdf(attachments)}
            >
              <div className="pdf_logo">
                <img
                  src={`${iconData?.find(
                    (i) => i.extension === attachments?.split(".").pop()
                  )?.icon
                    }`}
                  alt=""
                  className="  attachLogoActivity"
                />
              </div>
            </div>
          ) : (
            attachments.startsWith("https://") && (
              <div
                onClick={() =>
                  window.open(attachments, "_blank", "noopener,noreferrer")
                }
                className="all_pdf_pre"
                style={{ cursor: "pointer" }}
              >
                <div className="pdf_logo">
                  <img
                    src="/images/link-icon.png"
                    alt=""
                    className="  attachLogoActivity"
                  />
                </div>
              </div>
            )
          )}
          <div>
            <div>
              <img
                src="/images/cross.svg"
                alt=""
                onClick={(e) => {
                  e.stopPropagation();
                  setIsOpenPopup(true);
                }}
                // handleAttach(id, e)}
                style={{ float: "right" }}
              />
            </div>
            <div className="pdf_detail" style={{ marginLeft: "0px" }}>
              <div className=" d-flex align-itens-center justify-content-between">
                {/* {newPreRead ? <span className="pdf-txt1">{newPreRead?.subject_name}</span> : null} */}
              </div>
              {/* <div className="pdf-txt2">{attach && attach?.name}</div> */}
              {attachments.startsWith("https://") ? (
                <div className="pdf-txt2" title={generateLinkName(attachments)}>
                  {generateLinkName(attachments)}
                </div>
              ) : (
                <>
                  <div className="pdf-txt2" title={attachformat(attachments)}>
                    {attachformat(attachments)}
                  </div>
                  <div style={{ fontSize: "13px", height: "17px" }}>
                    {fileSize ? fileSize + " kb" : ""}
                  </div>
                </>
              )}

              {/* <div className="pdf-txt3">500 KB</div> */}
            </div>
          </div>
        </div>
      </div>
      {mideaviewer && (
        <MideaViewer
          closeMideaviewer={setMideaviewer}
          attachment={responseAttach}
        />
      )}

      {isClicked &&
        (responseAttach.split(".").pop() === "MP4" ||
          responseAttach.split(".").pop() === "mp4" ? (
          <div className="fullSizeImg">
            <div className="SubfullSizeImg">
              <video className="videoPlayer" controls>
                <source
                  src={IP + responseAttach.replace(/^\./, "")}
                  type="video/mp4"
                />
              </video>
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/images/cross.png"
                  alt="Up Arrow"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="fullSizeImg">
            <div className="SubfullSizeImgSummary">
              {!isError ? (
                <>
                  <img
                    className="imgMain"
                    src={IP + responseAttach?.replace(/^\./, "")}
                    alt="Full-size"
                    onError={(e) => {
                      setIsError(true);
                    }}
                  />
                  <div>
                    <img
                      className="crossIconImgQue"
                      onClick={handleClick}
                      src="/images/cross.png"
                      alt="Up Arrow"
                    />
                  </div>
                </>
              ) : (
                <div
                  className="fullSizeImg"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <img
                    onClick={() => {
                      handleClick();
                      setIsError(false);
                    }}
                    src="/images/cross.png"
                    alt="Up Arrow"
                    style={{ position: "absolute", top: "75px", right: "40%" }}
                  />
                  <img
                    src="/images/no-photo-1.png"
                    alt="img"
                    style={{ width: "25%" }}
                  />
                  <p
                    style={{
                      color: "red",
                      fontSize: "20px",
                      fontWeight: "500",
                      marginRight: "35px",
                    }}
                  >
                    Error!! failed to load the requested file!
                  </p>
                </div>
              )}
            </div>
          </div>
        ))}
      {isOpenPopup && (
        <ConfirmationPopup
          setIsOpenPopup={setIsOpenPopup}
          handleAttach={handleAttach}
          id={id}
        />
      )}
    </div>
  );
}

export default AttachmentLM;
